<template>
  <div
    style="background-color: white;height: 100%;width: 100%;position: fixed;top: 0;left: 0;right: 0;bottom: 0; z-index: 9999; overflow: hidden;"
  >
    <div class="d-flex justify-content-end m-4">
      <img
        src="../../assets/images/ui/icon_close.svg"
        width="20px"
        height="20px"
        style="cursor: pointer;"
        @click="handleClosed()"
      />
    </div>
    <div class="container">
      <pre
        style="height: auto; max-height: 90vh; overflow: auto; background-color: #eeeeee; word-break: normal !important; word-wrap: normal !important; white-space: pre !important;"
        >{{ signifiResponse }}</pre
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ['signifiResponse'],
  methods: {
    handleClosed() {
      this.$emit('on-close-clicked');
    },
  },
};
</script>
